import React from 'react';
import styles from './OverlayInfoSign.module.scss';

const OverlayInfoSign = ({ text, className = '', style = {} }) => {
  return (
    <span
      className={`${styles.container} ${className}`}
      style={style}
    >
      {text}
    </span>
  );
};

export default OverlayInfoSign;
